import styled from 'styled-components';
import { LabelRegularBoldM } from '../../../../styles/globals';
import { IThemeProvider } from '../../../../styles/theme';

export const ResultTableTitle = styled(LabelRegularBoldM)`
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]};
  `}
`;
